<template>
    <div class="estadisticas">
        <div class="mb-4">
            <label for="tiempo" class="form-label fw-bold">Seleccionar rango de tiempo:</label>
            <select v-model="tiempoSeleccionado" @change="obtenerDatos" class="form-select w-auto">
                <option value="7">Últimos 7 días</option>
                <option value="30">Últimos 30 días</option>
                <option value="90">Últimos 3 meses</option>
            </select>
        </div>
        <div class="mb-5">
            <vistas :dias="tiempoSeleccionado" />
            <eventos :dias="tiempoSeleccionado" />
        </div>
    </div>
</template>

<script>

import vistas from "./graficas/vistas.vue";
import eventos from "./graficas/eventos.vue";

export default {
    name: "EstadisticasVisitas",
    components: { vistas, eventos },
    data() {
        return {
            tiempoSeleccionado: "7",
        };
    },
    methods: {

    },
};
</script>

<style scoped>
.estadisticas {
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
</style>
